import { RequestStatus } from "../../../requester/request/request.types";

/**
 * Filter interface for expert requests
 */
export interface IExpertRequestFilter {
    search?: string;                          // Search term
    f_status?: RequestStatus;                 // Filter by status
    f_speciality?: string;                    // Filter by expertise area
    f_request_type?: string;                  // Filter by request type
    f_reading?: boolean;                      // Filter by reading status
    sort?: string;                           // Sort field and direction
    page?: number;                           // Page number (default: 1)
    per_page?: number;                       // Items per page (default: 20)
}

/**
 * Sort object from Spring Data
 */
export interface ISortObject {
    empty: boolean;
    sorted: boolean;
    unsorted: boolean;
}

/**
 * Pageable object from Spring Data
 */
export interface IPageableObject {
    offset: number;
    sort: ISortObject;
    pageSize: number;
    pageNumber: number;
    paged: boolean;
    unpaged: boolean;
}

/**
 * Spring Data Page response structure
 */
export interface IPageExpertRequestOut {
    totalElements: number;
    totalPages: number;
    size: number;
    content: any[];
    number: number;
    sort: ISortObject;
    first: boolean;
    last: boolean;
    numberOfElements: number;
    pageable: IPageableObject;
    empty: boolean;
}

/**
 * Converted pagination response for easier frontend use
 */
export interface IRequestPagination {
    currentPage: number;              // 1-based current page number
    pageSize: number;                // Items per page
    totalItems: number;              // Total number of items
    totalPages: number;              // Total number of pages
    hasNext: boolean;                // Has next page
    hasPrevious: boolean;            // Has previous page
    isFirst: boolean;                // Is first page
    isLast: boolean;                 // Is last page
    numberOfElements: number;        // Elements in current page
}

/**
 * Medical Opinion creation interface
 */
export interface IMedicalOpinionCreate {
    opinion: string;                         // Opinion text (required)
    status?: 'DRAFT' | 'SENT';              // Opinion status (optional, defaults to backend)
    attachmentMetadata?: string;             // Optional metadata
}

/**
 * Expert dashboard statistics
 */
export interface IExpertStats {
    totalRequests: number;
    unreadCount: number;
    waitingCount: number;                    // For pending requests
    inProgressCount: number;                 // For contributions
    completedCount: number;
    byRequestType: { [key: string]: number };
}

/**
 * Helper function to convert Spring Data Page to frontend pagination
 */
export function convertPageToPagination(page: IPageExpertRequestOut): IRequestPagination {
    return {
        currentPage: page.number + 1,        // Convert from 0-based to 1-based
        pageSize: page.size,
        totalItems: page.totalElements,
        totalPages: page.totalPages,
        hasNext: !page.last,
        hasPrevious: !page.first,
        isFirst: page.first,
        isLast: page.last,
        numberOfElements: page.numberOfElements
    };
}